import React from 'react';
import Img from '../../img/Img';
import text from '../../../text';
import LinkButton from '../../button/LinkButton';
import routes from '../../../routes/constants';
import cn from 'classnames';

const EmptyState = ({ className }: { className?: string }) => {
  return (
    <div className={cn('empty-state-container', className)}>
      <Img
        img='file-manager-fallback-illustration'
        // @ts-expect-error - type error from jsx
        alt={text('startNewProject')}
      />
      {/* @ts-expect-error - type error from jsx */}
      <LinkButton to={routes.mp.root} className='start-project-link'>
        {text('startANewProject')}
      </LinkButton>
      <p className='text-center px-3 font-14 font-weight-400'>
        {text('emptyStateInstructions')}
      </p>
    </div>
  );
};

export default EmptyState;
